import React, { useEffect, useState, useRef } from 'react';
import { Container, Complemento } from './styles1';

import LogoErpWorks from "~/assets/logos/Logo ErpWorks Proposta.png";

function Pagina1({ data }) {

  return (
    <>
      <Container>
        <div className="barra-sup"></div>
        <div className="barra-sup2"></div>
        <div className="barra-sup3"></div>
        <div className="barra-sup4"></div>
        <div className="header">
          <div class="text">
            <p class="titulo">Data Emissão</p>
            <p class="titulo-data">{(new Date().toLocaleString('pt-BR', { timeZone: 'UTC' }))}</p>
          </div>
        </div>
        <div className="body">
          <div className="mid">
            <img src={LogoErpWorks} alt="Logo Erpworks" />
          </div>
          <div className="bottom">
            <div class="text">
              <p class="titulo">Proposta</p>
              <p class="sub-titulo">COMERCIAL</p>
            </div>
            <div className="numero-os">
              <p class="titulo">SD{data?.id + (data?.versao ? " - " + data?.versao : "")}</p>
            </div>
          </div>
        </div>
      </Container >
    </>
  );
};

export default Pagina1;